import { createSelector } from '@reduxjs/toolkit';
import { getSelectedShareIds } from '../sharedLinks/selectors';
import { getStore } from '../../models/rootSelector';

export const getSharedLinksRemover = createSelector(getStore, (state) => state.sharedLinksRemover);
export const getBulkJobID = createSelector([getSharedLinksRemover], (sharedLinksRemover) => {
  return sharedLinksRemover.bulkJobID;
});

export const getEnabled = createSelector([getSelectedShareIds], (selected) => {
  return selected.length > 0;
});
